import { render, staticRenderFns } from "./Ledgers.vue?vue&type=template&id=53f721f4&"
import script from "./Ledgers.vue?vue&type=script&lang=js&"
export * from "./Ledgers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports